import React, { useState, useRef } from 'react';
import { isMobile, getDebugger } from '@/biz/tool';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import {
  getPlatformAudienceTutorialScreenshot,
  getPlatformAudienceTutorialScreenshotStep
} from '@/biz/platform';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import ModalShowImage from '@/components/web/components/ModalShowImage';

const ModalAnalysisAudienceTutorialScreenshot = () => {
  const { setShowModalShowImage } = useWebModalStore();
  const { detailData } = useDetailDataStore();

  const screenshotList = getPlatformAudienceTutorialScreenshot({
    platform: detailData?.order?.platform
  });
  const screenshotStepList = getPlatformAudienceTutorialScreenshotStep({
    platform: detailData?.order?.platform
  });

  return (
    <div className="self-stretch p-4 bg-[#f9f9fb] rounded-lg inline-flex flex-col justify-center items-start gap-6">
      <div className="justify-start text-[#60646c] text-sm font-normal font-['Inter']">
        Navigate to your channel’s analytics report and take screenshots. Please
        refer to the instructions below:
      </div>
      <div
        className={`self-stretch grid gap-2.5 
          ${isMobile() ? 'grid-cols-1 mb-20' : 'grid-cols-3'}
        `}
      >
        {screenshotList?.map((url, index) => {
          return (
            <div
              key={index}
              className="inline-flex flex-col justify-center items-center gap-2.5"
            >
              <img
                alt={`screenshot-${index}`}
                onClick={() => {
                  setShowModalShowImage(true, url);
                }}
                className="w-full rounded-lg border border-[#d9d9e0] cursor-pointer"
                src={url}
              />
              <div className="text-center justify-start text-[#60646c] text-xs font-medium font-['Inter']">
                {screenshotStepList[index]}
              </div>
            </div>
          );
        })}
      </div>
      <ModalShowImage />
      {/*  */}
    </div>
  );
};

export default ModalAnalysisAudienceTutorialScreenshot;
